// extracted by mini-css-extract-plugin
module.exports = {"container":"vv","bottomGradient":"vw","image":"vx","brandLogoFrame":"vy","logoImage":"vz","logoImageFrame":"vA"};